<template>
    <div class="renderer">
        <div class="content">
            <div class="contxt">
                <div class="overflowy">
                    <div class="picture">
                        <img src="../static/status_bar.png">
                    </div>
                </div>
                <div class="scrollCon">
                    <div class="scroll-box">
                        <div class="scroll-content-box">
                            <!--标题栏额外独立-->
                            <nav-section
                                v-if="template.page.navSection"
                                :item="template.page"
                            />
                            <draggable v-model="rendererList" @add="onAdd" @update="onUpdate" :scroll="true" :animation="150" group="renderer" ghostClass="ghost-view">
                                <div @click="onClick(item,index)" class="item" :class="{'item-active': itemIndex === index}" v-for="(item, index) in rendererList" :key="index" :id="index">
                                    <headerSerc
                                        v-if="item.name === 'headerSerch'"
                                        :item="item"
                                    />
                                    <swiperBg
                                        v-if="item.name === 'swiperBg'"
                                        :item="item"
                                    />
                                    <news
                                        v-if="item.name === 'news'"
                                        :item="item"
                                    />
                                    <menus
                                        v-if="item.name === 'menus'"
                                        :item="item"
                                    />
                                    <guide
                                        v-if="item.name === 'guide'"
                                        :item="item"
                                    />
                                    <imageBanner
                                        v-if="item.name === 'imageBanner'"
                                        :item="item"
                                    />
                                    <imageBannerLR
                                        v-if="item.name === 'imageBannerLR'"
                                        :item="item"
                                    />
                                    <storeSelect
                                        v-if="item.name === 'storeSelect'"
                                        :item="item"
                                    />
                                    <shopSelect
                                        v-if="item.name === 'shopSelect'"
                                        :item="item"
                                    />
                                    <promotionList
                                        v-if="item.name === 'promotionList'"
                                        :item="item"
                                    />
                                    <coupon
                                        v-if="item.name === 'coupon'"
                                        :item="item"
                                    />
                                    <combination
                                        v-if="item.name === 'combination'"
                                        :item="item"
                                    />
                                    <seckill
                                        v-if="item.name === 'seckill'"
                                        :item="item"
                                    />
                                    <good-list
                                        v-if="item.name === 'goodList'"
                                        :item="item"
                                    />
                                    <good-waterfall
                                        v-if="item.name === 'goodWaterfall'"
                                        :item="item"
                                    />
                                    <magic-cube
                                        v-if="item.name === 'magicCube'"
                                        :item="item"
                                    />
                                    <videoView
                                        v-if="item.name === 'videoView'"
                                        :item="item"
                                    />

                                    <div class="delete-box" v-if="itemIndex === index">
                                        <div class="options">
                                            <div class="option-item" @click.stop="deleteItem(index)">
                                                <i class="el-icon-delete"></i>
                                            </div>
                                            <div class="option-item" @click.stop="upItem(index)">
                                                <i class="el-icon-arrow-up"></i>
                                            </div>
                                            <div class="option-item" @click.stop="downItem(index)">
                                                <i class="el-icon-arrow-down"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </div>
                </div>
                <div class="overflowy"></div>
            </div>
        </div>
        <div class="acticons">
            <div class="acticons-item" @click="addSetting(template)">
                <span>页面设置</span>
            </div>
            <div class="acticons-item">
                <span>重置</span>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import bus from '@/components/common/bus';
import headerSerc from '@/components/decoration/material/headerSerc/headerSerc.vue';
import swiperBg from '@/components/decoration/material/swiperBg/swiperBg';
import news from  '@/components/decoration/material/news/news.vue';
import menus from '@/components/decoration/material/menus/menus.vue';
import guide from '@/components/decoration/material/guide/guide.vue';
import imageBanner from '@/components/decoration/material/imageBanner/imageBanner.vue';
import imageBannerLR from '@/components/decoration/material/imageBannerLR/imageBannerLR.vue';
import goodList from '@/components/decoration/material/goodList/goodList.vue';
import goodWaterfall from '@/components/decoration/material/goodWaterfall/goodWaterfall.vue';
import storeSelect from '@/components/decoration/material/storeSelect/storeSelect.vue';
import shopSelect from '@/components/decoration/material/shopSelect/shopSelect.vue';
import promotionList from '@/components/decoration/material/promotionList/promotionList.vue';
import coupon from '@/components/decoration/material/coupon/coupon.vue';
import combination from '@/components/decoration/material/combination/combination.vue';
import seckill from '@/components/decoration/material/seckill/seckill.vue';
import navSection from '@/components/decoration/material/navSection/navSection.vue';
import magicCube from '@/components/decoration/material/magicCube/magicCube.vue'
import videoView from '@/components/decoration/material/videoView/videoView.vue';

import { get, post } from '@/utils/request';
import { verificationAddCommon } from '@/components/decoration/constant';

export default {
    components:{
        draggable,
        bus,
        headerSerc,
        swiperBg,
        news,
        menus,
        guide,
        imageBanner,
        imageBannerLR,
        goodList,
        goodWaterfall,
        storeSelect,
        shopSelect,
        promotionList,
        coupon,
        combination,
        seckill,
        navSection,
        magicCube,
        videoView,
    },
    data() {
        return {
            rendererList: [],
            itemIndex: null, // 选中那一项的索引
            flag: true,

            template: {
                title: "页面设置",
                name: "pageSetting",
                page:{
                    name: '', // 模板名称
                    title: '', // 页面标题
                    navSection: false,
                    popUp:{
                        content: '', //弹窗内容
                        title: '', //弹窗内容
                        showStatus: false, //弹窗显示状态
                    },
                    pageColor: {
                        title: '背景颜色',
                        name: 'bgColor',
                        default: [
                            {
                                item: '#f8f8f8'
                            }
                        ],
                        color: [
                            {
                                item: '#f8f8f8'
                            }
                        ]
                    },
                    popUpAd:{
                        list: [{
                            id: Date.now(),
                            showStatus: false,
                            title: "",
                            pageLink: "",
                            pic: "",
                            showType: {
                                title: "显示模式",
                                type: 1,
                                list: [
                                    {
                                        key: "一次",
                                        value: 1,
                                    },
                                    {
                                        key: "启动",
                                        value: 2,
                                    },
                                    {
                                        key: "每日",
                                        value: 3,
                                    }
                                ]
                            },
                        }],
                    }
                },
            },
        };
    },
    created() {
        // 监听物料区添加
        bus.$off('addRenderer');
        bus.$on('addRenderer',(e)=>{
            if(verificationAddCommon(this.rendererList, e)){
                bus.$emit('addSetting',e)
                this.rendererList.push(e)
                this.itemIndex = this.rendererList.length - 1
            }
        })
        // 监听设置区更新
        bus.$off('updataRenderer');
        bus.$on('updataRenderer',(e)=>{
            this.updataRenderer(e);
        })
        // 监听保存方法
        bus.$off('onSubmit');
        bus.$on('onSubmit',(e)=>{
            this.editTemplate();
        })

        this.getTemplate();
    },
    mounted() {
        // 页面加载完成设置区默认显示页面模板设置
        this.addSetting(this.template)
    },
    methods:{
        // 获取模板
        getTemplate(){
            get(`/mpp/appdecor/get`,{
                id: this.$route.query.id
            }).then((res) =>{
                if(res.success){
                   if(res.mppAppDecor.decorContent){
                       let decorContent = JSON.parse(res.mppAppDecor.decorContent.replaceAll('&quot;','"'))
                       this.rendererList = decorContent.pageData;
                       this.template.page = {...this.template.page,...decorContent};
                       delete this.template.pageData;
                   }
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },

        //保存模板
        editTemplate(){
            console.log("11111111111111111调用的修改")
            if(this.flag){
                this.flag = false
                let decorContent = {
                    ...this.template.page,
                    pageData: this.rendererList
                }
                post(`/mpp/appdecor/edit`,{
                    id: this.$route.query.id,
                    decorContent: JSON.stringify(decorContent)
                }).then((res) => {
                    if (res.success) {
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            duration: 2000
                        });
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                    this.flag = true
                });
            }
        },

        // 新点击进入渲染区的物料向设置区域添加
        onClick(item,index){
            this.itemIndex = index
            this.addSetting(item)
        },

        // 拖拽更新渲染区的物料向设置区域添加
        onUpdate(e){
            this.itemIndex = e.newDraggableIndex
            this.addSetting(e.item._underlying_vm_)
        },

        // 新拖入渲染区的物料向设置区域添加
        onAdd(e){
            // 由于 onAdd 触发时组件已经被添加到 rendererList 中
            // 所以需要创建一个不包含新组件的临时数组来检测
            const newItem = e.item._underlying_vm_;
            const newIndex = e.newDraggableIndex;
            
            // 创建临时数组（不包含刚添加的组件）用于验证
            const tempList = this.rendererList.filter((item, index) => index !== newIndex);
            
            // 使用临时数组进行验证
            if(verificationAddCommon(tempList, newItem)){
                // 验证通过，保留组件并设置选中
                this.itemIndex = newIndex;
                this.addSetting(newItem);
            } else {
                // 验证失败，移除刚添加的组件
                this.$nextTick(() => {
                    this.rendererList.splice(newIndex, 1);
                });
            }
        },

        // 修改渲染器
        updataRenderer(obj){
            // 修改模板配置
            if(obj.name === "pageSetting"){
                this.template = obj;
            } else {
                this.rendererList[this.itemIndex] = obj;
            }
            this.$forceUpdate()
        },

        // 派发设置事件
        addSetting(obj){
            bus.$emit('addSetting',obj)
        },

        // 删除当前操作项
        deleteItem(index){
            this.rendererList.splice(index, 1)
            // 删除切换到页面设置
            if(index === this.itemIndex){
                this.itemIndex = null
                this.addSetting(this.template)
            }
            this.$forceUpdate()
        },

        // 向上移动
        upItem(index){
            if(index != 0){
                const temp = this.rendererList[index - 1]
                this.rendererList.splice(index - 1,1,this.rendererList[index])
                this.rendererList.splice(index,1,temp)
                this.itemIndex = index - 1
                this.$forceUpdate();
                console.log("this.itemIndex",this.itemIndex)
            }
        },

        // 向下移动
        downItem(index){
            if(index != this.rendererList.length - 1){
                const temp = this.rendererList[index]
                this.rendererList.splice(index,1,this.rendererList[index + 1])
                this.rendererList.splice(index + 1,1,temp)
                this.itemIndex = index + 1
                this.$forceUpdate();
                console.log("this.itemIndex",this.itemIndex)
            }
        }
    }
};
</script>

<style scoped lang='scss'>
.renderer{
    width: 100%;
    height: 100%;
    padding-top: 20px;
    background-color: #eee;
    display: flex;
    justify-content: center;
    .content{
        position: relative;
        padding-top: 0;
        height: 100%;
        width: 100%;
        overflow: hidden;
        .contxt{
            display: flex;
            flex-direction: column;
            overflow: hidden;
            height: 100%;
            .overflowy{
                overflow-y: scroll;
                &::-webkit-scrollbar{
                    width: 2px;
                }
                .picture{
                    width: 350px;
                    height: 20px;
                    margin: 0 auto;
                    background-color: #fff;
                }
            }
            .scrollCon{
                overflow-y: scroll;
                overflow-x: hidden;
                &::-webkit-scrollbar{
                    width: 2px;
                }
                .scroll-box{
                    width: 350px;
                    margin: 0px auto;
                    .scroll-content-box{
                        background-color: #f5f5f5;
                        width: 350px;
                        margin: 0 auto;
                        padding-top: 1px;
                        background-image: none;
                        background-repeat: no-repeat;
                        background-size: 100%;
                        height: calc(100vh - 225px);

                        .item{
                            position: relative;
                            &:hover{
                                box-shadow: 0 0 10px 0 rgba(24,144,255,.3);
                                transform: scale(1.01);
                            }
                            .delete-box{
                                display: block;
                                position: absolute;
                                top: 0;
                                width: 350px;
                                height: 100%;
                                border: 2px solid #0256ff;
                                .options{
                                    position: absolute;
                                    right: -40px;
                                    width: 30px;
                                    height: 90px;
                                    background-color: #0256ff;
                                    border-radius: 3px;
                                    display: flex;
                                    flex-direction: column;
                                    .option-item{
                                        flex: 1;
                                        width: 100%;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        color: #fff;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .acticons{
        margin-right: 10px;
        width: 80px;
        .acticons-item{
            width: 100%;
            height: 30px;
            margin-bottom: 10px;
            border: 1px solid #dcdfe6;
            border-radius: 3px;
            background-color: #fff;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            &:hover{
                background-color: #ccddff;
                border: 1px solid #99bbff;
                color: #0256ff;
            }
        }
    }
}
</style>